import React from 'react';
import { useDocumentVaultContext } from '../../context/useDocumentVaultContext';
import { SelectHouseholdMemberModal } from '../SelectHouseholdMemberModal/SelectHouseholdMemberModal';
import { AuthenticateFidelityEntity } from '../AuthenticateFidelityEntity/AuthenticateFidelityEntity';
import { useFidelityTokenId } from '../../hooks/useFidelityTokenId';

export const FidelityAuthentication = () => {
  const { selectedEntity } = useDocumentVaultContext();

  const { getCurrentTokenId } = useFidelityTokenId();

  const currentTokenId = getCurrentTokenId();

  if (
    (!currentTokenId && selectedEntity?.requestUserAuthentication) ||
    selectedEntity?.forceUserAuthentication
  ) {
    return <AuthenticateFidelityEntity />;
  }

  if (!currentTokenId && selectedEntity?.authenticationProfileModalEnabled) {
    return <SelectHouseholdMemberModal />;
  }

  return null;
};
